import { HomeHero } from 'scripts/animations/three/home-hero';
import {
    BackSide,
    FrontSide,
    MeshBasicMaterial,
    MeshPhongMaterial,
    MeshPhysicalMaterial,
} from 'three';

export const PrimaryIconMaterial = new MeshPhongMaterial({
    name: 'PrimaryIconMaterial',
    side: FrontSide,
    fog: false,
    ...HomeHero.Colors.Primary.violet,
});

export const SecondaryIconMaterial = new MeshPhysicalMaterial({
    name: 'SecondaryIconMaterial',
    side: FrontSide,
    ...HomeHero.Colors.Secondary.violet,
});

export const BackfaceMaterialFront = new MeshBasicMaterial({
    name: 'BackfaceMaterialFront',
    color: HomeHero.Colors.Backface.violet,
    side: FrontSide,
});

export const BackfaceMaterialBack = new MeshBasicMaterial({
    name: 'BackfaceMaterialBack',
    color: HomeHero.Colors.Backface.violet,
    side: BackSide,
});

export const FrontLeftMaterial = new MeshBasicMaterial({
    name: 'FrontLeftMaterial',
    side: FrontSide,
    map: null,
});

export const FrontRightMaterial = new MeshBasicMaterial({
    name: 'FrontRightMaterial',
    side: FrontSide,
    map: null,
});
